module.exports = __webpack_public_path__ + "img/Maradona-9.f77d3ed6.webp";